import type { FC } from 'react';
import { useContext } from 'react';
import { PapiGallection } from '@wix/da-papi-types';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import { BiLoggerContextProvider } from '@wix/da-bi/pkg/BiLogger.context';
import { ResourceType } from '@wix/da-shared-react/pkg/types/resource';
import StashFolderDesktop from './StashFolderDesktop';
import StashFolderMobile from './StashFolderMobile';
import { STASH_FOLDER_DEVIATIONS_STREAM } from '../../../constants';
import { useNormalizedDeviationStream } from '@wix/da-shared-react/pkg/utils/hooks/useStream';
import DeviationDuperbrowsableContext from '@wix/da-shared-react/pkg/Duperbrowse/DeviationDuperbrowseContext';

export interface Props {
  folder: PapiGallection;
  subfolders?: PapiGallection[];
  isFetchingFolders?: boolean;
  duperbrowseStreamVersion?: number;
  fetchMoreResults: () => void;
  copyFolderLink: (folder: PapiGallection) => void;
}

const StashFolder: FC<Props> = ({ folder, duperbrowseStreamVersion, ...props }) => {
  const isMobile = useContext(MobileContext);

  const { streamId, streamConfig, streamThrottle } = STASH_FOLDER_DEVIATIONS_STREAM;
  const { items: deviations } = useNormalizedDeviationStream(
    streamId,
    streamThrottle,
    streamConfig
  );

  return (
    <DeviationDuperbrowsableContext
      streamId={`stash-${duperbrowseStreamVersion}`}
      deviations={deviations}
      parent={{ title: 'Back' }}
    >
      <BiLoggerContextProvider
        value={{
          component: 'stash_visitor',
          view: 'stash',
          typeid: ResourceType.STASH_FOLDER,
          itemid: folder.folderId,
          page_typeid: ResourceType.STASH_FOLDER,
          page_itemid: folder.folderId,
        }}
      >
        {isMobile ? (
          <StashFolderMobile folder={folder} {...props} />
        ) : (
          <StashFolderDesktop folder={folder} {...props} />
        )}
      </BiLoggerContextProvider>
    </DeviationDuperbrowsableContext>
  );
};
StashFolder.displayName = 'StashFolder';

export default StashFolder;
